import { useQuery } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getUserNotificationsUnseenCount } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "./queryKeys";

export function useUnseenNotificationCountQuery() {
  return useQuery({
    queryKey: NOTIFICATIONS_QUERY_KEYS.unseenCount(),
    queryFn: processResponse(() => getUserNotificationsUnseenCount()),
    refetchInterval: 60_000,
  });
}
